var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('locations-table',{attrs:{"params":{ ids: _vm.ids, account: _vm.account, allSelected: _vm.allSelected, filters: _vm.filters }}})}
var staticRenderFns = []

export { render, staticRenderFns }